// extracted by mini-css-extract-plugin
export default {"Main":"WorkingHours_Main__QZNNm"};